import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//

import ArtistAvatar from '@/components/home/ArtistAvatar';
export default {
  name: 'artist-list',
  components: {
    ArtistAvatar: ArtistAvatar
  },
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    handleItemClick: function handleItemClick(content) {
      var _ref = content || {},
        jumpUrl = _ref.jumpUrl,
        dataSeed = _ref.dataSeed;
      if (!jumpUrl) return;
      if (dataSeed) {
        window.seedAction(Object.assign({}, dataSeed, {
          needTag: true
        }));
      }
      this.go(jumpUrl, {
        _blank: true
      });
    }
  }
};